module.exports = __webpack_public_path__ + "static/media/pencil.afc89771.svg";